// Helpers for the Pilot CRM "Top-12 skills" cache (Phase 3 of
// ASAP_PARTNERS_15.05). The same chip strip renders in three places
// (company detail modal, company kanban card, contact kanban card) and the
// backend ships either the new {name, family} shape, a legacy flat string
// list, or a JSON-encoded string of either. Keep the normalisation and the
// family colour scheme here so all three sites stay in lockstep.

// Skill-family -> Chakra chip colorScheme. Matches the convention used
// throughout the app (NeedDetailModal, MissionDetailModal, etc.). Unknown
// or null family falls back to gray so a chip never renders blank.
export const FAMILY_COLOR_SCHEME = {
  technical: "purple",
  functional: "orange",
  business: "green",
};

export const familyColor = (family) =>
  FAMILY_COLOR_SCHEME[family] || "gray";

// Hard caps applied at the two render sites so the magic numbers don't
// drift away from the documented contract (top-12 in the detail modal,
// 5-chip preview on the kanban cards).
export const MAX_TOP_SKILLS_DETAIL = 12;
export const MAX_TOP_SKILLS_KANBAN = 5;

// Decode the cache field and return [{name, family}] entries. Tolerates:
//   - already-decoded arrays (camelCase or snake_case payloads)
//   - JSON-encoded strings (legacy storage shape)
//   - lists of bare strings (pre-Phase-3 callers)
// Malformed JSON is logged once and treated as empty so a backend serialisation
// regression is visible in dev tools instead of silently dropping chips.
export function normalizeTopSkills(raw) {
  let parsed = raw;
  if (typeof raw === "string" && raw.trim().length > 0) {
    try {
      parsed = JSON.parse(raw);
    } catch (err) {
      console.warn("[pilotSkills] Failed to parse top_skills payload", raw, err);
      parsed = null;
    }
  }
  if (!Array.isArray(parsed)) return [];
  return parsed
    .map((entry) => {
      if (entry && typeof entry === "object") {
        const name = String(entry.name ?? "").trim();
        const family = entry.family
          ? String(entry.family).toLowerCase()
          : null;
        return name ? { name, family } : null;
      }
      const name = String(entry ?? "").trim();
      return name ? { name, family: null } : null;
    })
    .filter(Boolean);
}
